import React, { useEffect, useState } from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import {
  Description as RequestIcon,
  Send as SentIcon,
  CheckCircle as FulfilledIcon,
  Pending as PendingIcon,
  Warning as OverdueIcon,
  Edit as DraftIcon,
} from '@mui/icons-material';
import { praAPI } from '../services/api';

const StatCard = ({ title, value, icon, color }) => (
  <Card>
    <CardContent>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography color="textSecondary" gutterBottom variant="body2">
            {title}
          </Typography>
          <Typography variant="h4" component="div">
            {value}
          </Typography>
        </Box>
        <Box sx={{ fontSize: 40, color }}>
          {icon}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const Dashboard = () => {
  const [stats, setStats] = useState({
    total_requests: 0,
    draft_requests: 0,
    sent_requests: 0,
    fulfilled_requests: 0,
    pending_requests: 0,
    overdue_requests: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await praAPI.getDashboardStats();
        setStats(response.data);
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return <Typography>Loading dashboard...</Typography>;
  }

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Overview of your PRA requests
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Total Requests"
            value={stats.total_requests}
            icon={<RequestIcon />}
            color="#1976d2"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Draft Requests"
            value={stats.draft_requests}
            icon={<DraftIcon />}
            color="#757575"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Sent Requests"
            value={stats.sent_requests}
            icon={<SentIcon />}
            color="#2196f3"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Pending Responses"
            value={stats.pending_requests}
            icon={<PendingIcon />}
            color="#ff9800"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Fulfilled Requests"
            value={stats.fulfilled_requests}
            icon={<FulfilledIcon />}
            color="#4caf50"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Overdue Requests"
            value={stats.overdue_requests}
            icon={<OverdueIcon />}
            color="#f44336"
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Dashboard;
